import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
export const isNewFontEnabled = window.location.search.includes('newFont=true');
// Font weights need to correspond with the imports at the top of the file
const fontWeightLight = 300;
const fontWeightRegular = 400;
const fontWeightMedium = isNewFontEnabled ? 500 : 700;
const fontWeightBold = isNewFontEnabled ? 600 : 900;
/**
 * Theme typography options that are the same across both the dark and light themes.
 */ export const typography = {
    fontFamily: isNewFontEnabled ? '"Inter", sans-serif' : '"Lato", sans-serif',
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold,
    h1: {
        fontSize: '1.5rem',
        fontWeight: isNewFontEnabled ? fontWeightBold : fontWeightMedium,
        lineHeight: '32px'
    },
    h2: {
        fontSize: '1.25rem',
        fontWeight: isNewFontEnabled ? fontWeightBold : fontWeightMedium,
        lineHeight: '28px'
    },
    h3: {
        fontSize: '1rem',
        fontWeight: isNewFontEnabled ? fontWeightBold : fontWeightMedium,
        lineHeight: '24px'
    },
    h4: {
        fontSize: '0.875rem',
        fontWeight: isNewFontEnabled ? fontWeightBold : fontWeightMedium,
        lineHeight: '22px'
    },
    h5: undefined,
    h6: undefined,
    body1: {
        fontSize: '0.875rem',
        fontWeight: fontWeightRegular,
        lineHeight: '20px'
    },
    body2: {
        fontSize: '0.75rem',
        fontWeight: fontWeightRegular,
        lineHeight: '18px'
    },
    subtitle1: {
        fontSize: '1rem',
        fontWeight: fontWeightRegular,
        lineHeight: '24px',
        letterSpacing: '0.02rem'
    },
    subtitle2: {
        fontSize: '0.875rem',
        fontWeight: fontWeightMedium,
        lineHeight: '22px',
        letterSpacing: '0.03rem',
        textTransform: 'uppercase'
    },
    button: {
        // 14px
        fontSize: '0.875rem',
        fontWeight: fontWeightMedium,
        // 20 px
        lineHeight: '1.25rem',
        textTransform: 'none',
        letterSpacing: '0.03rem'
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: fontWeightRegular,
        lineHeight: '16px'
    },
    overline: undefined,
    overline1: {
        fontSize: '0.875rem',
        fontWeight: fontWeightRegular,
        lineHeight: '20px',
        letterSpacing: '0.08rem',
        textTransform: 'uppercase'
    },
    overline2: {
        fontSize: '0.75rem',
        fontWeight: fontWeightRegular,
        lineHeight: '18px',
        letterSpacing: '0.08rem',
        textTransform: 'uppercase'
    },
    code: {
        // Use system default monospace font
        fontFamily: 'monospace',
        fontSize: '0.75rem',
        fontWeight: fontWeightRegular,
        lineHeight: '20px'
    }
};

//# sourceMappingURL=typography.js.map